// extracted by mini-css-extract-plugin
module.exports = {"detailsTitle":"DetailsTitle_detailsTitle__pyZ6f"};